module.exports = __webpack_public_path__ + "static/media/arashiyama-japan.c4b0423f.jpg";